/**
 * External dependencies
 */
import React from 'react';
import page from 'page';

/**
 * Internal dependencies
 */
import MainComponent from './main';

import DataComponent from './data/main';
import LocationsComponent from './locations/main';
import FtpComponent from './ftp/main';

export const index = (context, next) => {
    context.primary = <MainComponent  />;
    next();
};

export const data = (context, next) => {
    context.primary = <DataComponent />;
    next();
};

export const locations = (context, next) => {
    context.primary = <LocationsComponent />;
    next();
};

export const ftp = (context, next) => {
    context.primary = <FtpComponent />;
    next();
};